import React from "react";
import axios from "axios";
import "../auth.css";
import "../card.css";
import "../sidemenu.css";
import "../just.css";
import { reactLocalStorage } from "reactjs-localstorage";
import i18n from "../i18n";
import { connect } from "react-redux";
import Menutest from "./menu.js";
import Table from "react-bootstrap/Table";
import {Button, Segment,Label,Icon} from "semantic-ui-react";
import { SemanticToastContainer, toast } from "react-semantic-toasts";
import "react-semantic-toasts/styles/react-semantic-alert.css";
//import { withScriptjs, withGoogleMap, GoogleMap, Marker, InfoWindow, MapWithAMarker, Data} from "react-google-maps";
import { Circle,Trash } from "react-google-maps";
import {LoadScript, GoogleMap, DrawingManager, Polygon, Polyline, Marker, InfoWindow, MapWithAMarker} from "@react-google-maps/api";
//import {DrawingManager} from "react-google-maps/lib/components/drawing/DrawingManager";
//import { Circle } from "react-google-maps";
//import { Descriptions } from 'antd';
import Geocode from "react-geocode";
import AutoComplete from "react-google-autocomplete";
import { API_BASE_URL } from "../utils/endpoints";
Geocode.setApiKey("AIzaSyDIV-I4FCXCL1mlcHpVYsxC-fVX_hY-5xo")
const libraries = ["drawing" , "places"];
const google = window.google;
const googleKey = {
  key: "AIzaSyDIV-I4FCXCL1mlcHpVYsxC-fVX_hY-5xo",
  libraries: ['drawing','places'].join(',')
}
const IconTrashDetailsa = {
  marginTop: 30,
  marginLeft: "15%",
  height: "auto",
};

var options = {
  drawingControl: true,
  drawingControlOptions: {
   
    drawingModes: ["circle"]
  },
  
  circleOptions: {
    fillColor: `#2196F3`,
    strokeColor: `#2196F3`,
    fillOpacity: 0.5,
    strokeWeight: 2,
    clickable: true,
    editable: true,
    draggable: true,
    zIndex: 1,
    radius: 2000
    
  }
};

const labels = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
let labelIndex = 0;
var drawingManager;
var all_overlays = [];

var selectedShape;
var colors = ['#1E90FF', '#FF1493', '#32CD32', '#FF8C00', '#4B0082'];
var selectedColor;
var colorButtons = {};

const polygonRef =null;
const circleRef = null;
const listenersRef = [];
class GoogelUser extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      radius:0,
      allEdits:[],
      map: null,
      path: [],
      isDrawing: false,
      shapes: [],
      drawingModes: ['circle'],
      address: "",
      city: "",
      area: "",
      state: "",
      zoom: 14,
      height: 400,
      mapPosition: {
        lat: '0',
        lng: '0'
      },
      markerPosition: {
        lat: '0',
        lng: '0'
      },
      circleData:[],
      pathCircle: [],
      Object:{}
    };


    this.handleOverlayComplete = this.handleOverlayComplete.bind(this);
    this.deleteShapes = this.deleteShapes.bind(this);
    this.clearSelection = this.clearSelection.bind(this);
    this.setSelection = this.setSelection.bind(this);
    this.deletSelectedSahape = this.deletSelectedSahape.bind(this);
    this.mapMounted = this.mapMounted.bind(this);
    this.shouldComponentUpdateshouldComponentUpdate = this.shouldComponentUpdateshouldComponentUpdate.bind(this);
    this.getvalues = this.getvalues.bind(this);
    
  }
  mapMounted (ref) {
    this.map = ref;
  };

  shouldComponentUpdateshouldComponentUpdate(nextProps, nextState) {
    return false;
  }

  getvalues (e) {
    const radius = this.map.getRadius();
    const center = this.map.getCenter();
    this.setState({ radius: radius });
    this.setState({
      "mapPosition.lat": center.lat(),
      "mapPosition.lng": center.lng()
    });
   console.log('raduis',this.setState.radius)
  };

  

  handleOverlayComplete(e) {
    const newshape = e.overlay;
    newshape.type = e.type;
    
    window.google.maps.event.addListener(newshape, "click", () => {
      this.setSelection(newshape);
     
    });
    this.setSelection(newshape);
    
    this.state.shapes.push(newshape)
   

    options = {
      drawingControl: true,
      drawingControlOptions: {
       
        drawingModes: []
      },
      
      circleOptions: {
        fillColor: `#2196F3`,
        strokeColor: `#2196F3`,
        fillOpacity: 0.5,
        strokeWeight: 2,
        clickable: true,
        editable: true,
        draggable: true,
        zIndex: 1,
        radius: 2000
        
      }
    };

  }

  clearSelection() {
    if (selectedShape) {
      selectedShape.setEditable(false);
      selectedShape = null;
    }
  }


  setSelection(shape) {
    this.clearSelection();
    selectedShape = shape;
    shape.setEditable(true);
    //selectColor(shape.get('fillColor') || shape.get('strokeColor'));
  }

  /* toggleSelection(shape) 
  {
    selectedShape = shape;
    if (selectedShape.getEditable() === true) selectedShape.setEditable(false);
    else selectedShape.setEditable(true);
  } */

  deletSelectedSahape(){
    if(selectedShape){
      var index = this.state.circleData.indexOf(selectedShape);
      console.log(index)
      this.state.circleData.splice(index, 1);
      console.log("allahapes after removing one", this.state.circleData)
      selectedShape.setMap(null);

      
    }
  }

  deleteShapes() {
    var array = []
    this.setState({circleData:array});
    this.state.shapes.forEach(shape => shape.setMap(null));
    console.log(this.state.circleData);
  }

 

  noDraw = () => {
    this.setState(function set(prevState) {
      return Object.assign({}, prevState, {
        drawingMode: "maker"
      });
    });
  };

  onPolygonComplete = function onPolygonComplete(poly) {
    const polyArray = poly.getPath().getArray();
    let paths = [];
    polyArray.forEach(function (path) {
      paths.push({ lat: path.lat(), lng: path.lng() });
    });
    this.setState({ path: paths });
    console.log("onPolygonComplete", paths);
    //this.noDraw();
    //poly.setMap(null);
   
  };


  onPolylineComplete = function onPolylineComplete(line){
   
      const lineArray = line.getPath().getArray()
       console.log(lineArray)
       let paths = [];
       lineArray.map(path =>{
       paths.push({ lat: path.lat(), lng: path.lng() });
    }); 
     this.setState({ path: paths });
     console.log("onPolylineComplete", paths);
     this.noDraw();
    // line.setMap(null); 
     console.log('dMN')
  };

   onCircleComplete=(circle) => {
    document.getElementById("button").disabled = false
    
    console.log('circle',circle)
      const circlelat = circle.getCenter().lat()
      const circleLang = circle.getCenter().lng()
      const radius= circle.radius
      const circlesArray =[];
      
      var Object = {'long': circleLang, 'lat' : circlelat, 'radius': radius };
      this.setState({Object:Object})
      console.log("Object", Object)
      console.log(circleLang , circlelat, radius)
      if(this.state.circleData.length < 4 ){
       // this.state.circleData.push(Object)
      }
      else {
        console.log("over")
      }
      
      console.log(this.state.circleData)
    
      this.noDraw();
     
 
      window.google.maps.event.addListener(circle, 'radius_changed',(event) => {
        
        console.log('circle radius changed', circle.getRadius());
         var radius= circle.getRadius()
         console.log(radius)
         var object = {'long': circleLang, 'lat' : circlelat, 'radius':radius};
         console.log("Object", object)
         this.setState({Object:object})
        
           
      });
  
         window.google.maps.event.addListener(circle, 'center_changed',  (event) =>  {
          
          console.log('circle center changed',  circle.getCenter().toUrlValue(15));
           var circleLang = circle.getCenter().lng()
           var circlelat = circle.getCenter().lat()
          var  object = {'long': circleLang, 'lat' : circlelat, 'radius':radius};
           this.setState({Object:object})
           
  
      });

      options = {
        drawingControl: false,
        drawingControlOptions: {
         
          drawingModes: []
        },
        
        circleOptions: {
          fillColor: `#2196F3`,
          strokeColor: `#2196F3`,
          fillOpacity: 0.5,
          strokeWeight: 2,
          clickable: true,
          editable: true,
          draggable: true,
          zIndex: 1,
          radius: 2000
          
        }
      };
  
  
    };

    Save =() =>{
      var array=[]
      for( var key in this.state.Object){
        array.push(key)
      }
       if(array.length >0) {
        var Object=this.state.Object
        this.state.circleData.push(Object)
      
      }
      var ob={}
      this.setState({Object:ob})
      console.log("save",this.state.circleData)
     // document.querySelector('.button').sty
     document.getElementById("button").disabled = true
     options = {
      drawingControl: true,
      drawingControlOptions: {
       
        drawingModes: ["circle"]
      },
      
      circleOptions: {
        fillColor: `#2196F3`,
        strokeColor: `#2196F3`,
        fillOpacity: 0.5,
        strokeWeight: 2,
        clickable: true,
        editable: true,
        draggable: true,
        zIndex: 1,
        radius: 2000
        
      }
    };
    }
   
    

    circleSubmit = () => {
      if(this.state.circleData.length> 0){
        var token = reactLocalStorage.get("accessToken");
      var ip = API_BASE_URL;
      var s2 = "localhost:3000";
      var apiBaseUrl;
       var data ={"area":this.state.circleData,
      "area_name":"test"}
      if (ip.includes(s2)) {
        apiBaseUrl =
          API_BASE_URL + "/core/user/rest/general/createPredefinedArea";
      } else {
        apiBaseUrl = API_BASE_URL + "/core/user/rest/general/createPredefinedArea";
      }
      var headers = {
        token: token,
      };
      axios
        .post(apiBaseUrl, data, { headers: headers })
        .then(function(response) {
          if (response.status === 200) {
            if (response.data.result != undefined) {
              if (response.data.status === "success") {
               console.log(response.data.status)
              } else {
                toast({
                  type: "warning",
                  title: i18n.t("warning.label"),
                  description: response.data.status,
                  animation: "bounce",
                  time: 5000,
                });
              }
            }
          } else if (response.status === 204) {
            console.log("Something wrong");
            toast({
              type: "error",
              title: i18n.t("error.label"),
              description: i18n.t("Something_wrong.label"),
              animation: "bounce",
              time: 5000,
            });
          } else {
            console.log("Something wrong");
            toast({
              type: "error",
              title: i18n.t("error.label"),
              description: i18n.t("Something_wrong.label"),
              animation: "bounce",
              time: 5000,
            });
          }
        })
        .catch(function(error) {
          console.log(error);
          toast({
            type: "error",
            title: i18n.t("error.label"),
            description: i18n.t("Something_wrong.label"),
            animation: "bounce",
            time: 5000,
          });
        });

      }
      
    };

//////////////////////////////////////////
///NOT : Use to change position of shap///
/////////////////////////////////////////
  /*  onEdit = ()=> {
    console.log(polygonRef,"polygonRef")
   if (polygonRef.current) {
      const nextPath = polygonRef.current
        .getPath()
        .getArray()
        .map((latLng) => {
          return { lat: latLng.lat(), lng: latLng.lng() };
        });
        this.setState({ path:nextPath})
    } 
  } */  
//////////////////////////////////////////
  onEdit = () => {
    console.log("circleRef", circleRef)
    this.onCircleComplete();
    /* if (circleRef.current) {
      const nextPath = circleRef.current
        .getPath()
        .getArray()
        .map((latLng) => {
          return { lat: latLng.lat(), lng: latLng.lng() };
        });
        this.setState({ path:nextPath})
    } */
  }  

//////////////////////////////////////////
///NOT :                               ///
/////////////////////////////////////////
  onLoad =(circle) => {
    console.log("circle", circle)
      /*  polygonRef.current = polygon;
      
      const path = polygon.getPath();
      listenersRef.current.push(
        path.addListener("set_at", this.onEdit.bind(this)),
        path.addListener("insert_at",  this.onEdit.bind(this)),
        path.addListener("remove_at", this.onEdit.bind(this))
      );  */
    }; 
//////////////////////////////////////////


//////////////////////////////////////////
///NOT :                               ///
/////////////////////////////////////////
  onUnmount =()=>{
    /* listenersRef.current.forEach(listener=>listener.remove());
    polygonRef.current=null; */
    
  }; 
 //////////////////////////////////////////
  componentDidMount() {
    document.getElementById('button').disabled=true
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(position => {
        this.setState({
          mapPosition: {
            lat: position.coords.latitude,
            lng: position.coords.longitude,
          },
          markerPosition: {
            lat: position.coords.latitude,
            lng: position.coords.longitude,
          }
        }, () => {
          Geocode.fromLatLng(position.coords.latitude, position.coords.longitude)
            .then(response => {
              console.log('response', response)
              const address = response.results[0].formatted_address,
                addressArray = response.results[0].address_components,
                city = this.getCity(addressArray),
                area = this.getArea(addressArray),
                state = this.getState(addressArray);
              //console.log(city, area, state);
              this.setState({
                address: (address) ? address : "",
                area: (area) ? area : "",
                city: (city) ? city : "",
                state: (state) ? state : "",

              })

            })
        })
      })
    }

  };


  getCity = (addressArray) => {
    let city = '';
    for (let index = 0; index < addressArray.length; index++) {
      if (addressArray[index].types[0] && 'administrative_area_level_2' === addressArray[index].types[0]) {
        city = addressArray[index].long_name;
        return city;
      }
    }

  }
  ////
  getArea = (addressArray) => {
    let area = '';
    for (let index = 0; index < addressArray.length; index++) {
      if (addressArray[index].types[0]) {
        for (let j = 0; j < addressArray.length; j++) {
          if ('sublocality_level_1' === addressArray[index].types[j] || 'locality' === addressArray[index].types[j]) {
            area = addressArray[index].log_name;
            return area;
          }
        }

      }
    }

  }
  ///
  getState = (addressArray) => {
    let state = '';
    for (let index = 0; index < addressArray.length; index++) {
      for (let index = 0; index < addressArray.length; index++) {
        if (addressArray[index].types[0] && 'administrative_area_level_2' === addressArray[index].types[0]) {
          state = addressArray[index].log_name;
          return state;
        }

      }

    }
  }
  ////

  onMarkerDragEnd = (event) => {
    let newLat = event.latLng.lat();
    let newLng = event.latLng.lng();
    //addressArray =[];
    Geocode.fromLatLng(newLat, newLng)
      .then(response => {
        console.log('response', response)

        const address = response.results[0].formatted_address,
          addressArray = response.results[0].address_components,
          city = this.getCity(addressArray),
          area = this.getArea(addressArray),
          state = this.getState(addressArray);

        this.setState({
          address: (address) ? address : "",
          area: (area) ? area : "",
          city: (city) ? city : "",
          state: (state) ? state : "",
          mapPosition: {
            lat: newLat,
            lng: newLng
          },
          markerPosition: {
            lat: newLat,
            lng: newLng
          },

        })
      })

  }
  ///
  onPlaceSelected = (place) => {
    const address = place.formatted_address,
      addressArray = place.address_components,
      city = this.getCity(addressArray),
      area = this.getArea(addressArray),
      state = this.getState(addressArray),
      newLat = place.geometry.location.lat(),
      newLng = place.geometry.location.lng();
    this.setState({
      address: (address) ? address : "",
      area: (area) ? area : "",
      city: (city) ? city : "",
      state: (state) ? state : "",
      mapPosition: {
        lat: newLat,
        lng: newLng
      },
      markerPosition: {
        lat: newLat,
        lng: newLng
      },

    })

  }
  ///

  onInfoWindowClose = (event) => { };
  
  ////

  



  render() {
    return (
      <>              
       {/*  <div style={{ padding: '0rem', margin: '0 auto', maxWidth: 900 }}><h1></h1>   
          <Descriptions bordered>
            <Descriptions.Item label="City">{this.state.city}</Descriptions.Item>
            <Descriptions.Item label="Area">{this.state.area}</Descriptions.Item>
            <Descriptions.Item label="State">{this.state.state}</Descriptions.Item>
            <Descriptions.Item label="Adress">{this.state.address}</Descriptions.Item>
          </Descriptions>
        </div> */}

        <LoadScript googleMapsApiKey={googleKey.key} libraries={libraries}
          id="script-loader"
          language="en">
          <GoogleMap          
            center={{ lat: this.state.mapPosition.lat, lng: this.state.mapPosition.lng }}
            mapContainerClassName={'map-style'}
            zoom={10}
            onClick={this.clearSelection}
             radius={this.state.radius}
             onRadiusChanged={this.getvalues}
          >
           

     
            {this.state.path.length===0 ? (
           
              <DrawingManager
            
            drawingMode={this.state.drawingMode}
            options={options}
            
            onCircleComplete={this.onCircleComplete.bind(this)}               
            editable
            draggable
          // Event used when manipulating and adding points
          onMouseUp={this.onEdit}
          // Event used when dragging the whole Polygon
          onDragEnd={this.onEdit}
          onOverlayComplete={this.handleOverlayComplete}
          
          />
          
            ) : (
             
                <Polygon
                  options={{
                    //fillColor: `#2196F3`,
                    //strokeColor: `#2196F3`,
                    fillOpacity: 0.45,
                    strokeWeight: 0
                  }}
                  // Make the Polygon editable / draggable
                  editable
                  draggable
                  path={this.state.path}
                // Event used when manipulating and adding points
                  onMouseUp={this.onEdit}
                //// Event used when dragging the whole Polygon
                onDragEnd={this.onEdit}
                onLoad={this.onLoad}
                onUnmount={this.onUnmount}
                />
                ||
                <Polyline
                  options={{
                    fillColor: `#2196F3`,
                    strokeColor: `#2196F3`,
                    fillOpacity: 0.5,
                    strokeWeight: 2,                            
                  }}
                  // Make the Polygon editable / draggable
                  editable
                  draggable
                  path={this.state.path}
                // Event used when manipulating and adding points
                  onMouseUp={this.onEdit}
                //// Event used when dragging the whole Polygon
                onDragEnd={this.onEdit}
                onLoad={this.onLoad}
                onUnmount={this.onUnmount}
                />
               ||
                <Circle
                options={{
                  //fillColor: `#2196F3`,
                  //strokeColor: `#2196F3`,
                  fillOpacity: 0.45,
                  strokeWeight: 0,                      
                }}
                onClick={()=>{this.onSelect()}}
                onRightClick={()=>{this.onSelect()}}
                onRadiusChanged={console.log("me")}
                //ref={this.mapMounted}
               // radius={this.state.radius}
               // onRadiusChanged={this.getvalues}
               // center={ this.state.mapPosition}
                // Make the Polygon editable / draggable
                editable={false}
                visible={true}
                draggable ={false}
                //path={this.state.path}
              // Event used when manipulating and adding points
                onMouseUp={this.onEdit}
              //// Event used when dragging the whole Polygon
            //  onEdit = {this.getvalues}
             // onDragEnd={this.getvalues}
              onLoad={this.onLoad}
             // onUnmount={this.getvalues}
                    
                
                />          
                
              )}
            {this.state.path.map((pos, key) => {
              console.log(pos);
              return <Marker key={key} label={"" + key} position={pos} />;
            })}       

          </GoogleMap>
        </LoadScript>
        <div >
        <Button onClick={this.deletSelectedSahape} color='red'>
          Delete selected</Button>

          <Button onClick={this.deleteShapes} color="red">
            Delete All Sahpes
          </Button>

          <Button className="button"  id="button" onClick={this.Save} color='red' >
          SAVE</Button>
          </div>
          

          
      </>
    );

  }

}
export default GoogelUser;


//https://stackoverflow.com/questions/44156349/failed-to-display-react-google-maps-searchbox


///https://www.outsystems.com/forums/discussion/34206/how-do-i-add-center-changed-and-radius-changed-events-to-a-circle-on-google-maps/
//https://stackoverflow.com/questions/14751800/how-to-get-the-radius-after-editing-circle-google-maps-ap%C3%AD
//https://stackoverflow.com/questions/12004550/how-to-delete-all-the-shape-after-draw/12006751





//////////////////////////////////////////
//https://stackoverflow.com/questions/24956635/what-event-is-triggered-if-a-google-maps-drawn-circle-is-moved
//https://stackoverflow.com/questions/29101088/what-event-is-triggered-if-a-google-maps-drawing-like-ondraw
//http://jsfiddle.net/upsidown/k0ye3v9z/
//https://stackoverflow.com/questions/12004550/how-to-delete-all-the-shape-after-draw/12006751
///https://www.outsystems.com/forums/discussion/34206/how-do-i-add-center-changed-and-radius-changed-events-to-a-circle-on-google-maps/